import { EntityStore, EntityState, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { IEventLogDetails } from 'typings/doenkids/doenkids';

export interface IOrganizationUnitFetchEventsState extends EntityState<IEventLogDetails> {
  limit: number;
  skip: number;
  total: number;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'organization-fetch-events' })
export class OrganizationUnitFetchEventsStore extends EntityStore<IOrganizationUnitFetchEventsState> {
  constructor() {
    super([]);
  }

  setMetadata({ total, skip, limit }) {
    this.update({ total, skip, limit });
  }
}
